import { useRef } from 'react';
import Players from 'components/3catinfo/Players';
import clsx from 'clsx';
import styles from '../cosNoticia.module.scss';

const Audio = (props) => {
    const { id } = props;
    const playerRef = useRef();

    const stylesMedia = clsx({
        [styles.media]: true,
        [styles.mediaAudio]: true
    });

    return (
        <div className={stylesMedia} data-testid='cos-noticia-media-audio'>
            <div className={styles.audio}>
                <Players ref={playerRef} {...props} tipus='audioNotiRelacionat' id={id} playerVideoTagId={`audio-noticia-${id}`} />
            </div>
        </div>
    );
};

export default Audio;
